import React from "react";
// COMPONENTS
import SelectBanks from "../../../../components/select/SelectBanks";
import SelectLifts from "../../../../components/select/SelectLifts";
// INTERFACES
import { FEMessage } from "../../../../../interfaces/AdapterCdoModbus.interface";

export default function ComponentFrontEndMsg({
	value,
	onChange,
	disabledInput = false,
}: {
	value: FEMessage;
	onChange: (newValue: FEMessage) => void;
	disabledInput?: boolean;
}) {
	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeBank = (id: string, name: string) => {
		onChange({
			...value,
			bank_id: id,
			bank_name: name,
			lift_id: "",
			lift_name: "",
		});
	};

	const onChangeLift = (id: string, name: string) => {
		onChange({
			...value,
			lift_id: id,
			lift_name: name,
		});
	};

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired'>*</span>
						<span className='drawer__text'>LN2 Bank</span>
					</div>
					<div className='generalStyles__width100'>
						<SelectBanks
							inputValue={value.bank_id}
							inputOnChange={(id: string, name: string) =>
								onChangeBank(id, name)
							}
							disabledInput={disabledInput}
						/>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>

			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired'>*</span>
						<span className='drawer__text'>LN2 Lift</span>
					</div>
					<div className='generalStyles__width100'>
						<SelectLifts
							inputValue={value.lift_id}
							inputOnChange={(id: string, name: string) =>
								onChangeLift(id, name)
							}
							disabledInput={disabledInput}
							bankId={value.bank_id}
						/>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
		</>
	);
}
